import type { ReactNode } from 'react'

export function MetaRow({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <li className="flex items-center gap-2 text-muted-foreground text-sm sm:text-base">
      <span className="shrink-0 [&_svg]:size-4">{icon}</span>
      <span className="min-w-0 truncate">{children}</span>
    </li>
  )
}
